import { Eyebrow, Reveal } from "./Reveal";

export default function QuoteBanner({ parts, eyebrow, testid }) {
  return (
    <section className="border-y border-neon/10 bg-panel px-5 py-20 sm:px-8 sm:py-28" data-testid={testid}>
      <Reveal className="mx-auto max-w-4xl text-center">
        <Eyebrow>{eyebrow}</Eyebrow>
        <p className="mt-6 font-serif text-3xl leading-snug tracking-tight text-cream sm:text-4xl lg:text-5xl">
          {parts.map((p, i) =>
            p.accent ? (
              <em key={i} className="italic text-neon">
                {p.text}
              </em>
            ) : (
              <span key={i}>{p.text}</span>
            )
          )}
        </p>
      </Reveal>
    </section>
  );
}
